/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfigurationForAiAgent extends models.ReportConfiguration {
    constructor() {
        super();
        this.setDiscriminator("ReportConfigurationForAiAgent");
    }

    getFixupPrototypeFunction() { return ReportConfigurationForAiAgent.fixupPrototype; }

    static newInstance(model: Partial<ReportConfigurationForAiAgent>): ReportConfigurationForAiAgent {
        let obj = Object.assign(new ReportConfigurationForAiAgent(), model);
        ReportConfigurationForAiAgent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfigurationForAiAgent>): ReportConfigurationForAiAgent {
        if (!model) return null;
        return ReportConfigurationForAiAgent.newInstance(<ReportConfigurationForAiAgent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfigurationForAiAgent) {
        if (!obj) return;

        models.ReportConfigurationForAiAgent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfigurationForAiAgent): boolean {
        if (models.ReportConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportConfigurationForAiAgent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Id of the Agent.
     */
    agent_id: string;

}
